function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M445 180.95h-22.4v-75.9c0-28.3-23-51.3-51.3-51.3h-320c-28.3 0-51.3 23-51.3 51.3v207.2c0 28.3 23 51.3 51.3 51.3h142v35.2h-43.5c-9.9 0-18 8.1-18 18s8.1 18 18 18h123.1c9.9 0 18-8.1 18-18s-8.1-18-18-18h-43.5v-35.2h40.2c9.9 0 18-8.1 18-18s-8.1-18-18-18H51.3c-8.4 0-15.3-6.8-15.3-15.3v-207.2c0-8.4 6.8-15.3 15.3-15.3h320c8.4 0 15.3 6.8 15.3 15.3v75.9h-22.4c-24 0-43.5 19.5-43.5 43.5v166.8c0 24 19.5 43.5 43.5 43.5h80.9c9.9 0 18-8.1 18-18s-8.1-18-18-18h-80.9c-4.1 0-7.5-3.3-7.5-7.5v-166.8c0-4.1 3.3-7.5 7.5-7.5h80.9c4.1 0 7.5 3.3 7.5 7.5v125.9c0 9.9 8.1 18 18 18s17.9-8.1 17.9-18v-125.9c0-24-19.5-43.5-43.5-43.5z"
});

function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488.5 488.5",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgDevices;